// =============================================
// Form Label Component
// KipiKid - תווית שדה עם אייקון עזרה אופציונלי
// =============================================

import HelpTooltip from './HelpTooltip';

interface FormLabelProps {
  text: string;
  required?: boolean;
  helpText?: string;
  htmlFor?: string;
  style?: React.CSSProperties;
}

export default function FormLabel({
  text,
  required = false,
  helpText,
  htmlFor,
  style,
}: FormLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      style={{
        fontSize: '13px',
        fontWeight: '500',
        color: '#1f2937',
        marginBottom: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        ...style,
      }}
    >
      {text}{required && ' *'}
      {helpText && <HelpTooltip text={helpText} />}
    </label>
  );
}
